import { useTranslation } from 'react-i18next'
import { useIsRequiredProperty } from '../../../../services/validation/requiredFieldsUtils/useIsRequiredProperty'
import { ContentStateProperty } from '../../../../@types/types'
import React from 'react'

export type TextLabelProps = {
  id: string
  propertyName?: ContentStateProperty
  labelClass?: string
  hideMandatorySign?: boolean
} & ( // Either labelTranslationKey or labelNode is required
  | {
      labelTranslationKey?: never
      labelNode: React.ReactNode
    }
  | {
      labelTranslationKey: string
      labelNode?: never
    }
)

export function InputLabel({
  id,
  propertyName,
  labelTranslationKey,
  labelNode,
  labelClass,
  hideMandatorySign = false,
}: TextLabelProps) {
  const isFieldMandatory = useIsRequiredProperty(propertyName ?? 'custom')

  const mandatory = !hideMandatorySign && isFieldMandatory && propertyName
  const { t } = useTranslation()

  return (
    <label className={`input-label ${mandatory ? 'mandatory' : ''}`} htmlFor={id} id={`${id}-input-label`}>
      <span className={labelClass}>{labelTranslationKey ? t(labelTranslationKey) : labelNode}</span>
    </label>
  )
}
